import styled, { css } from "styled-components"

import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import { Container as _Container } from "~/components/layouts/Container"
import { Color, IsMobile, IsPC, LineHeight, SpacingSize, TextSize } from "~/consts/style-mixins"
import { staticPath } from "~/services/helper"

const GraduatesVoice = () => {
  return (
    <Container size="Large">
      <Pc>
        <img src={staticPath("/static/images/course/graduates-voice-pc.svg")} />
      </Pc>
      <Sp>
        <img src={staticPath("/static/images/course/graduates-voice-sp.svg")} />
      </Sp>
      <p className="heading">長期インターンで活躍する卒業生の声</p>
      <p className="supplement">
        本講座でデータサイエンスの知識とスキルを習得し、その後データサイエンスに携わる長期インターンで活躍している卒業生の声をご紹介します。
      </p>
      <div className="graduates-wrapper">
        <div className="each-graduate">
          <img
            src={staticPath("/static/images/course/data-science/no-photo.jpg")}
            className="graduate-thumbnail"
            alt=""
          />
          <p className="comment">
            選考において技術試験があり
            <br />
            そこで学んだことを生かせました。
          </p>
          <p className="profile">
            明治大学 商学部 23卒 R.Sさん
            <br />
            インターン先：データビズラボ株式会社
          </p>
        </div>
        <div className="each-graduate">
          <img
            src={staticPath("/static/images/course/data-science/no-photo.jpg")}
            className="graduate-thumbnail"
            alt=""
          />
          <p className="comment">
            データサイエンスの流れが理解でき、
            <br />
            AI開発のインターンに合格できました。
          </p>
          <p className="profile">
            同志社大学大学院 理工学研究科 23卒 K.Oさん
            <br />
            インターン先：株式会社メタ・イズム
          </p>
        </div>
      </div>
    </Container>
  )
}

const Container = styled(_Container)`
  ${IsPC(css`
    padding: 64px 16px;
  `)}
  ${IsMobile(css`
    padding: 48px 16px;
  `)}
  .heading {
    font-size: ${TextSize["2XL"]}px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    margin-top: ${SpacingSize["4XL"]}px;
    ${IsMobile(css`
      font-size: 20px;
      margin-top: 32px;
    `)}
  }
  .supplement {
    font-size: ${TextSize.M}px;
    line-height: ${LineHeight.L}%;
    color: ${Color.Gray};
    margin-top: ${SpacingSize["3XS"]}px;
    ${IsMobile(css`
      margin-top: 8px;
    `)}
  }
  .graduates-wrapper {
    margin-top: ${SpacingSize["2XL"]}px;
    display: flex;
    justify-content: space-evenly;
    ${IsMobile(css`
      flex-flow: column;
    `)}
  }
  .each-graduate {
    text-align: center;
    color: ${Color.Gray};
    &:first-child {
      margin-bottom: ${SpacingSize["3XL"]}px;
    }
  }
  .graduate-thumbnail {
    width: 200px;
    height: 200px;
    margin-bottom: ${SpacingSize.S}px;
    border-radius: 50%;
  }
  .comment {
    margin-bottom: ${SpacingSize.XS}px;
    font-size: ${TextSize.M}px;
    font-weight: bold;
    line-height: ${LineHeight.M}%;
  }
  .profile {
    font-size: ${TextSize.S}px;
    line-height: ${LineHeight.S}%;
  }
`

export default GraduatesVoice
